import React from "react";
import { whiteColor, darkGrey } from "../assets/styles/base";

export default (props) => {
  const { content } = props;

  return (
    <span
      style={{
        padding: "3px 10px",
        margin: 3,
        borderRadius: 30,
        backgroundColor: darkGrey,
        width: "100%",
        color: whiteColor,
      }}
    >
      #{content}
    </span>
  );
};
